import { removeFalsy } from "helpers/formatter";
import { Circuit, CircuitExercise } from "models/circuit";
import apiService from "modules/api/apiService";
import { CIRCUIT_CRUD, CIRCUIT_LIST } from "modules/api/endpoint";
import { TPagination } from "modules/api/type";

// app/Domains/FacilityTasks/Jobs/Circuits/GetCircuitsJob.php
export const getCircuitList = async (
  params: any
): Promise<{
  success: boolean;
  data?: any[];
  pagination?: TPagination;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${CIRCUIT_LIST}${queryParams ? `?${queryParams}` : ""}`);

    return {
      data: results.data.payload.data,
      pagination: results.data.payload.pagination,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

// app/Domains/FacilityTasks/Jobs/Circuits/GetCircuitJob.php
export const getCircuitById = async (
  params: any
): Promise<{
  success: boolean;
  data?: Circuit;
}> => {
  let queryParams = params
    ? Object.keys(removeFalsy(params))
        .map((key) => `${key}=${params[key]}`)
        .join("&")
    : "";

  try {
    const results = await apiService.get(`${CIRCUIT_CRUD}${queryParams ? `?${queryParams}` : ""}`);
    let entry = results.data.payload[0];
    entry.exercises = entry.exercises as CircuitExercise[];

    return {
      data: entry,
      success: true,
    };
  } catch (error) {
    return { success: false };
  }
};

export const addCircuitEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    let result = await apiService.post(CIRCUIT_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const updateCircuitEntry = async (
  body: any
): Promise<{
  success: boolean;
  data?: any;
  message?: string;
}> => {
  try {
    let result = await apiService.put(CIRCUIT_CRUD, body);
    return {
      data: result,
      success: true,
    };
  } catch (e) {
    return {
      message: e.message,
      success: false,
    };
  }
};

export const deleteCircuitEntry = async (id: number) => {
  return apiService.del(`${CIRCUIT_CRUD}?id=${id}`);
};
